import React from "react";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";
import OurProducts from "./OurProducts";
import "../styles/homePage.css";

export default function Homepage() {
  return (
    <>
      {/*Carousel section*/}
      <Carousel />

      {/*Text-wrap section*/}
      <section className="text-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h1 className="main-title">
                <span>Welcome to</span> METAK India
              </h1>

              <p>
                <strong>METAK Healthcare India Pvt. Ltd. </strong> is established to be the Healthcare Company which focuses on Quality Aids to enable
                people to lead a healthy, painless, energetic, life and wish them a speedy recovery. METAK Healthcare India Pvt. Ltd. is growing and
                serving the Patients suffering from various Orthopedic Disorders &amp; Ailments and thus provides patients faster active lifestyle.
              </p>

              <p>
                We pride ourselves in our customer-centered approach from start to finish. From the convenience of extended business hours to the
                professional and friendly customer care atmosphere, we treat each customer like we would expect to be treated - with utmost care and
                respect.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="image-wrap">
        <div className="image-inner">
          <h2 className="image-text">
            we focus on superior quality, safety <br /> and affordability
          </h2>
          <Link to="/contact-us" className="mcare-button button1">
            Contact NOW
          </Link>
          <Link to="/about-us" className="mcare-button button2">
            Know MORE
          </Link>
        </div>
      </section>

      {/*Products & Testimonials section*/}
      <OurProducts />
    </>
  );
}
